/*=========================================================================================
  File Name: moduleNotificationsActions.js
  Description: Notifications Module Actions
==========================================================================================*/

import todoListGql from "@/http/requests/cbs/todo_list_gql";
import * as _ from "lodash";
export default {
	/**
	 * Get notifications by page
	 * @param {*} param0
	 * @param {*} payload
	 */
	fetchMissionday({ commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.fetchTodoOfToday(payload)
				.then(response => {
					commit("SET_MISSIONS", response.todoListToday);
					commit("SET_TOTAL_MISSIONS", response.totalTodoListToday);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	handleNewMissionFromSocket({ state, commit }, payload) {
		const idx = _.findIndex(state.missions, { id: payload.mission.id });
		if (idx === -1) {
			commit("ADD_NEW_MISSION", payload.mission);
		} else {
			commit("UPDATE_MISSION", payload.mission);
		}
		if (payload.audio) {
			commit("ADD_NEW_AUDIO", payload.audio);
		}
		commit("INDEX_UPDATE", idx === -1 ? 0 : idx);
	},
	deletePlayedAudio({ commit }, todoId) {
		commit("DELETE_AUDIO", todoId);
	},
	resetPlayList({ commit }, payload) {
		commit("RESET_LIST_AUDIO", payload);
	},
	resetPlayListEveryAnHour({ commit }) {
		commit("RESET_LIST_AUDIO_AN_HOUR");
	},
	deleteMission({ commit }, mission) {
		commit("DELETE_MISSION", mission);
	}
};
